export const maybeZero = (value: number | undefined) => {
  return value || 0;
};
